import ajax from './index'
import apiEnv from './apiEnv'
// 弹窗列表
export function messageBoxList(data) {
    return ajax.post(`${apiEnv.api1}/api/Admin/DialogsConfig/GetManagerDialogsConfigList`, data)
}
//弹窗列表上移下移
export function updateProductDomainSortNo(data) {
    return ajax.post(`${apiEnv.api1}/api/Admin/DialogsConfig/UpdateDialogsConfigSortNo`, data)
}
//弹窗列表启用禁用
export function updateDialogsConfigStatus(data) {
    return ajax.post(`${apiEnv.api1}/api/Admin/DialogsConfig/UpdateDialogsConfigStatus`, data)
}
//新增弹窗配置
export function addDialogsConfig(data) {
    return ajax.post(`${apiEnv.api1}/api/Admin/DialogsConfig/AddDialogsConfig`, data)
}
//编辑弹窗配置
export function updateDialogsConfig(data) {
    return ajax.post(`${apiEnv.api1}/api/Admin/DialogsConfig/UpdateDialogsConfig`, data)
}
//获取弹窗场景
export function listEnumItem(data) {
    return ajax.post(`${apiEnv.api1}/api/Code/ListEnumItem`, data)
}


//获取消息列表
export function getMessageList(data) {
    return ajax.post(`${apiEnv.api4}/api/Message/GetMessageList`, data)
}